import { Col, Row, Typography } from "antd";

import ShowParticipant from "./ShowParticipant.js";
import AddParticipant from "./AddParticipant.js";

const { Title } = Typography;

const plattler = {
    /*
    "1": "Freie Auswahl Gauplattler",
    "2": "Haushammer",
    "3": "Wendlstoana",
    "11": "Freie Auswahl Gauplattler",
    "12": "Inntaler",
    "4": "Inntaler",
    "5": "Sulzbergler",
    "6": "Heitauer",
    "7": "Mooswinkler",
    "8": "Freie Auswahl Gauplattler",
    "21": "Wendlstoana",
    "22": "Sulzbergler"
    */
    /*
    "4": "Heitauer",
    "5": "Sulzbergler",
    "6": "Mooswinkler",
    "7": "Innsbrucker",
    "8": "Freie Auswahl Gauplattler",
    "21": "Reit im Winkler",
    "22": "Rittpapier"
    */
};

function StartGroup(props) {
    /*
    console.log(props);
    if (plattler[props.startGroup.id]) {
        console.log(plattler[props.startGroup.id]);
    }
    */

    function renderAddParticipant() {
        if (props.readonly === false) {
            return (
                <AddParticipant
                    onClick={(values) =>
                        props.onAdd(props.startGroup.id, values)
                    }
                    group={props.startGroup.id > 10}
                />
            );
        }
    }

    function renderPlattler() {
        if (plattler[props.startGroup.id]) {
            return (
                <>
                    <Row>
                        <Col offset={2}>
                            <p>
                                <strong>Plattler:</strong>{" "}
                                {plattler[props.startGroup.id]}
                            </p>
                        </Col>
                    </Row>
                </>
            );
        } else {
            return null;
        }
    }

    return (
        <>
            <Row style={{ marginTop: 20 }}>
                <Col offset={2}>
                    <Title level={4}>{props.startGroup.name}</Title>
                </Col>
            </Row>
            {renderPlattler()}
            <Row gutter={[10, 10]} style={{ marginBottom: 10 }}>
                {props.participants.map((participant, index) => {
                    if (participant.startGroup === props.startGroup.id) {
                        return (
                            <ShowParticipant
                                key={index}
                                startGroup={participant.startGroup}
                                firstName={participant.firstName}
                                lastName={participant.lastName}
                                onClick={async () =>
                                    props.onDelete(
                                        participant.id,
                                        participant.startGroup,
                                    )
                                }
                                readonly={props.readonly}
                            />
                        );
                    } else return null;
                })}
            </Row>
            {renderAddParticipant()}
        </>
    );
}

export default StartGroup;
